"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Paper = _interopRequireDefault(require("../Paper/Paper"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _FBUIConstants = require("../../../../utils/FBUIConstants");

var _NoResultsModule = _interopRequireDefault(require("./NoResults.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoResults = function NoResults(_ref) {
  var title = _ref.title,
      redirectForNoResults = _ref.redirectForNoResults,
      redirectButtonText = _ref.redirectButtonText,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Paper.default, {
    className: _NoResultsModule.default.NoResultsContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _NoResultsModule.default.TypographySection
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: _FBUIConstants.TYPOGRAPHY_TYPES.HEADING_XL
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "img",
    "aria-label": "heartbreak"
  }, "\uD83D\uDC4B")), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: _FBUIConstants.TYPOGRAPHY_TYPES.HEADING_XL
  }, title)), children, /*#__PURE__*/_react.default.createElement("div", {
    className: _NoResultsModule.default.NoResultsBtnContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: redirectForNoResults,
    className: _NoResultsModule.default.NoResultsBtn
  }, redirectButtonText)));
};

NoResults.propTypes = {
  title: _propTypes.default.string.isRequired,
  redirectForNoResults: _propTypes.default.func.isRequired,
  redirectButtonText: _propTypes.default.string.isRequired,
  children: _propTypes.default.object
};
var _default = NoResults;
exports.default = _default;

//# sourceMappingURL=NoResults.js.map